module.exports = __webpack_public_path__ + "img/刘瑞.ffb4efd7.jpg";